<template lang="pug">
  .register-view
    .register-view-container
      .row.align-items-center
        register.col-sm-12.col-md-4
</template>
<script>
import Register from '../components/auth/Register.vue'

export default {
  components: {
    Register
  }
}
</script>
<style lang="scss">
.register-view{
  padding: 1rem;
  height: 100%;
  background: linear-gradient(0deg, #1F1F1F,#939393);
  &-container {
    height: 100%;
  }
}
.register-view {
  margin: auto;
  height: auto;
  min-height: 100%;
}
</style>
